export default __webpack_public_path__ + "static/media/image_malaysia.3a539cd9.png";